// extracted by mini-css-extract-plugin
export default {"pinCodeContainer":"pinCodeContainer--ywdQQ","digitInput":"digitInput--P47Aq","invalidate":"invalidate--Sqcqz","withTimeout":"withTimeout--t_nti","wrong":"wrong--u7owp"};